import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";

import Homepage from '../HomePage/HomePage'
import TeamPage from '../TeamPage/TeamPage';
import AttorneyDetail from '../AttorneyDetail/AttorneyDetail';
import Practices from '../Practices/Practices';
import PracticeDetails from '../PracticeDetails/PracticeDetails';
import Honoraires from '../Honoraires/Honoraires'
import NewsList from '../NewsList/NewsList'
import NewsDetails from '../NewsDetails/NewsDetails'
import ContactPage from '../ContactPage/ContactPage';
import Confidentialite from '../Privacy/PrivacyPage.js';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="equipe" element={<TeamPage />} />
          <Route path="equipe/:slug" element={<AttorneyDetail />} />
          <Route path="matieres" element={<Practices />} />
          <Route path="matieres/:slug" element={<PracticeDetails />} />
          <Route path="honoraires" element={<Honoraires />} />
          <Route path='news' element={<NewsList />} />
          <Route path='news/:slug' element={<NewsDetails />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='confidentialite' element={<Confidentialite />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
